import { getNavigatorLanguage } from './getNavigatorLanguage';

export const is24HourScale = ({ preferredLocale }: { preferredLocale?: string } = {}) => {
  const locale = preferredLocale || getNavigatorLanguage();
  if (!locale) {
    return false;
  }

  const formatter = new Intl.DateTimeFormat(locale, { hour: 'numeric' });

  // Check the hour cycle, 'h23' means 24-hour, 'h12' means 12-hour
  const is24Hour = formatter.resolvedOptions().hourCycle === 'h23';

  return is24Hour;
};
